export const formatLocationText = (city: string | undefined, state: string | undefined) => {
  if (city && state) {
    return `${city}, ${state}`
  } else if (city) {
    return city
  } else if (state) {
    return state
  }
  return '-'
}
